import type { PresetColor } from "react-color/lib/components/sketch/Sketch";

export const PRESET_COLORS: PresetColor[] = [
  {
    color: "#EF4444",
    title: "#EF4444",
  },
  {
    color: "#F97316",
    title: "#F97316",
  },
  {
    color: "#FACC15",
    title: "#FACC15",
  },
  {
    color: "#4ADE80",
    title: "#4ADE80",
  },
  {
    color: "#2DD4BF",
    title: "#2DD4BF",
  },
  {
    color: "#3B82F6",
    title: "#3B82F6",
  },
  {
    color: "#6366F1",
    title: "#6366F1",
  },
  {
    color: "#EC4899",
    title: "#EC4899",
  },
  {
    color: "#F43F5E",
    title: "#F43F5E",
  },
  {
    color: "#D946EF",
    title: "#D946EF",
  },
  {
    color: "#8B5CF6",
    title: "#8B5CF6",
  },
  {
    color: "#0EA5E9",
    title: "#0EA5E9",
  },
  {
    color: "#10B981",
    title: "#10B981",
  },
  {
    color: "#84CC16",
    title: "#84CC16",
  },
];
